import * as BookmarkTypes from 'common/types/reports/bookmark';
import {isWarehouseShowClause} from 'iron/common/report/insights/models/utils';
import {addToast} from 'common/components/toast-area/toast-manager';
import {getLocation} from 'common/util/url';

export function applyValidations(params: BookmarkTypes.InsightsBookmarkParams): BookmarkTypes.InsightsBookmarkParams {
  return validateWarehouseMetricsState(params);
}

export function shouldDisableFilters(params: BookmarkTypes.InsightsBookmarkParams): boolean {
  return shouldDisableBreakdownsWhenUsingWarehouseMetrics(params);
}

export function shouldDisableBreakdowns(params: BookmarkTypes.InsightsBookmarkParams): boolean {
  return (
    params.displayOptions.chartType === BookmarkTypes.ChartType.FunnelTopPaths ||
    shouldDisableBreakdownsWhenUsingWarehouseMetrics(params)
  );
}

/** disables breakdowns when a report includes one warehouse metric  */
export function shouldDisableBreakdownsWhenUsingWarehouseMetrics(params: BookmarkTypes.InsightsBookmarkParams) {
  return params.sections.show.some((clause) => isWarehouseShowClause(clause));
}

export function validateWarehouseMetricsState(
  params: BookmarkTypes.InsightsBookmarkParams,
): BookmarkTypes.InsightsBookmarkParams {
  if (
    shouldDisableBreakdownsWhenUsingWarehouseMetrics(params) &&
    (params.sections.group?.length || params.sections.filter?.length)
  ) {
    params.sections.filter = [];
    params.sections.group = [];

    addToast({
      message: (i18n) => i18n.t(`warehouse-metric-builder.filters-and-breakdowns-disabled`),
      ctaHref: getLocation().href,
      cta: `Undo`,
    });
  }

  return params;
}
